// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3jLCB","paramInput":"JobSimulator_paramInput__26W2v","input":"JobSimulator_input__1--bw"};